"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TERM = void 0;
var TERM;
(function (TERM) {
    TERM[TERM["TERMS"] = 0] = "TERMS";
    TERM[TERM["PRIVACY_POLICY"] = 1] = "PRIVACY_POLICY";
    TERM[TERM["NEWSLETTER"] = 2] = "NEWSLETTER";
})(TERM = exports.TERM || (exports.TERM = {}));
